import React, { FC } from 'react';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { FoldersDropdownContextType } from './foldersDropdown.types';

export const FoldersDropdownContext = React.createContext<
  FoldersDropdownContextType
>({
  showDropdown: false,
  searchValue: '',
  openDropdown: () => {},
  closeDropdown: () => {},
  saveSearchValue: () => {},
  errorMessage: '',
  saveErrorMessage: () => {},
});

type Props = {
  children: React.ReactNode;
};

type State = FoldersDropdownContextType;

export class FoldersDropdownProvider extends React.Component<Props, State> {
  openDropdown = () => {
    doctrineAnalytics('Folders ToggleAddToFoldersDropdown');
    this.setState(({ showDropdown }) => ({
      showDropdown: !showDropdown,
    }));
  };

  closeDropdown = () => {
    this.setState({ showDropdown: false, searchValue: '', errorMessage: '' });
  };

  saveSearchValue = (searchValue: string) => {
    this.setState({ searchValue, errorMessage: '' });
  };

  saveErrorMessage = (errorMessage: string) => {
    this.setState({ errorMessage });
  };

  state: State = {
    showDropdown: false,
    searchValue: '',
    errorMessage: '',
    openDropdown: this.openDropdown,
    closeDropdown: this.closeDropdown,
    saveSearchValue: this.saveSearchValue,
    saveErrorMessage: this.saveErrorMessage,
  };

  render() {
    return (
      <FoldersDropdownContext.Provider value={{ ...this.state }}>
        {this.props.children}
      </FoldersDropdownContext.Provider>
    );
  }
}

export const withFolderDropdown = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const ComponentWithDecision: FC<Pick<
    P,
    Exclude<keyof P, keyof FoldersDropdownContextType>
  >> = (props) => (
    <FoldersDropdownContext.Consumer>
      {(state: FoldersDropdownContextType) => (
        <Component {...(props as P)} {...state} />
      )}
    </FoldersDropdownContext.Consumer>
  );
  return ComponentWithDecision;
};
